import actions from "./actions";

const initState = {
    termCreateState: false,
    termCreateResult: {},

    terms: [],
    termsPagination: {},
    archiveTermStatus: false,
    deleteTermStatus: false,
    term: {
        name: undefined,
        description: undefined,
        type: 'in_days',
        value: 0,
        interest_on: false,
        interest_rate: undefined,
    },
    type: 'in_days',
    interestOn: false,
    createTermStatus: false, // request, success, error
    updateTermStatus: false,
    readTermStatus: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.READ_TERMS_SUCCESS:
            return {
                ...state,
                terms: action.terms,
                termsPagination: {
                    total: action.termsPagination.total,
                    current: action.termsPagination.current_page,
                    pageSize: action.termsPagination.per_page,
                },
            };
        case actions.ARCHIVE_TERM_REQUEST:
            return {
                ...state,
                archiveTermStatus: 'request',
            };
        case actions.ARCHIVE_TERM_SUCCESS:
            return {
                ...state,
                archiveTermStatus: 'success',
            };
        case actions.DELETE_TERM_REQUEST:
            return {
                ...state,
                deleteTermStatus: 'request',
            };
        case actions.DELETE_TERM_SUCCESS:
            return {
                ...state,
                deleteTermStatus: 'success',
            };
        case actions.DELETE_TERM_ERROR:
            return {
                ...state,
                deleteTermStatus: 'error',
            };
        case actions.READ_TERM_REQUEST:
            return {
                ...state,
                readTermStatus: 'request',
            };
        case actions.READ_TERM_SUCCESS:
            return {
                ...state,
                term: action.term,
                type: action.term.type,
                interestOn: action.term.interest_on,
                readTermStatus: 'success',
            };
        case actions.POPULATE_TERM:
            return {
                ...state,
                term: {
                    ...(action.reset ? initState.term : state.term),
                    ...action.payload,
                },
            };
        case actions.UPDATE_TYPE:
            return {
                ...state,
                type: (action.reset ? initState.type : action.payload),
            };
        case actions.SET_INTEREST_ON:
            return {
                ...state,
                interestOn: (action.reset ? initState.interestOn : action.interestOn),
            };
        case actions.CREATE_TERM_REQUEST:
            return {
                ...state,
                createTermStatus: 'request',
                termCreateState: 'request',
            };
        case actions.CREATE_TERM_SUCCESS:
            return {
                ...state,
                createTermStatus: 'success',
                termCreateState: 'success',
                termCreateResult: action.term,
            };
        case actions.UPDATE_TERM_REQUEST:
            return {
                ...state,
                updateTermStatus: 'request',
            };
        case actions.UPDATE_TERM_SUCCESS:
            return {
                ...state,
                updateTermStatus: 'success',
            };
        default:
            return state;
    }
}
